import { render, staticRenderFns } from "./rdbms.vue?vue&type=template&id=4fa1f202&scoped=true"
import script from "./rdbms.vue?vue&type=script&lang=ts"
export * from "./rdbms.vue?vue&type=script&lang=ts"
import style0 from "./rdbms.vue?vue&type=style&index=0&id=4fa1f202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1f202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
